import {
  ConnectionPositionPair,
  OriginConnectionPosition,
  OverlayConnectionPosition,
} from '@angular/cdk/overlay';
import { ElementRef, Signal } from '@angular/core';

export type ArrowPosition =
  | 'left'
  | 'lefttop'
  | 'top'
  | 'topleft'
  | 'righttop'
  | 'right'
  | 'rightbottom'
  | 'bottom'
  | 'leftbottom'
  | 'bottomleft'
  | null;

export class ComponentPositionPair extends ConnectionPositionPair {
  constructor(
    origin: OriginConnectionPosition,
    overlay: OverlayConnectionPosition,
    public arrowPosition: ArrowPosition,
    public offsetX = 0,
    public offsetY = 0,
  ) {
    super(origin, overlay);
  }
}

export enum ComponentTooltipPosition {
  BottomLeft = 'bottomleft',
  BottomRight = 'bottomright',
  TopLeft = 'topleft',
  TopRight = 'topright',
  Left = 'left',
  Right = 'right',
  RightTop = 'righttop',
  RightBottom = 'rightbottom',
  Top = 'top',
  Bottom = 'bottom',
  EndBottomEndTop = 'end-bottom-end-top',
}

export type ComponentTooltipPositions = Partial<
  Record<ComponentTooltipPosition, ComponentPositionPair>
>;

export enum ObserveOnElement {
  Self = 'self',
  Parent = 'parent',
  Custom = 'custom',
}

export type OverlayClipArea = [top: number, right: number, bottom: number, left: number];

export interface ComponentTooltipServiceConfig {
  // This is component instance on witch change detection will be performed
  context: any;
  positions: ComponentTooltipPositions;
  hasBackdrop: boolean;
  backdropClass?: string;
  overlayClipArea?: OverlayClipArea;
  observeOnElement?: ObserveOnElement;
  observeOnCustomElement?: Node | Signal<ElementRef<Node>>;
  withFallbackPoint?: boolean;
  withPush?: boolean;
}
